// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"5c872fec","950":"cad5d490"}[chunkId] + ".chunk.css";
};